<template>
  <v-app style="background-color: white">
    <app-drawer :title="appTitle" :logo="appLogo" :menu="menu"/>
    <app-toolbar :title="appTitle" @side-icon-click="showAppDrawer"/>
    <v-main>
      <v-container fluid class="pt-1" style="height: 100%">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive">
          </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive">
        </router-view>
      </v-container>
    </v-main>
    <app-message/>
    <!--    <app-drawer :title="appTitle" :logo="appLogo" :menu="menu"/>-->
    <!--    <app-toolbar :hideMenu="$route.query.menu=='false'" :title="appTitle" @side-icon-click="showAppDrawer"/>-->
    <!--    <v-main>-->
    <!--      <v-container fluid class="pt-1" style="height: 100%">-->
    <!--        <router-view></router-view>-->
    <!--      </v-container>-->
    <!--    </v-main>-->
    <!--    <app-message/>-->
  </v-app>
</template>
<script>
import AppToolbar from "../app/AppToolbar.vue";
import AppDrawer from "../app/AppDrawer.vue";
import AppMessage from "../app/AppMessage.vue";
import menu from "../../router/menu"

export default {
  components: {
    AppToolbar,
    AppDrawer,
    AppMessage
  },
  name: "app-main-layout",
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDrawer: true,
      menu: [],
      appTitle: 'POINTER INVESTMENT (H.K.) LTD.',
      appLogo: 'images/sunwin.png'
    };
  },
  created() {
    window.theApp.$on("APP_FULLSCREEN", () => {
      this.fullscreen = false;
    });
    window.theApp.$on("ROUTER_ROUTE", (routerInfo) => {
      if (routerInfo.router.meta && routerInfo.router.meta.fullscreen) {
        this.fullscreen = true;
      }
    })
    this.menu = menu;
  },
  methods: {
    showAppDrawer: function () {
      this.showDrawer = !this.showDrawer;
    }
  }
};
</script>
